// extracted by mini-css-extract-plugin
export default {"form":"ActionModal_form__mNK4U"};